// extracted by mini-css-extract-plugin
module.exports = {"o1a4a65x":"o1a4a65x","bex860w":"bex860w","fullpage":"fullpage","b1szgiyp":"b1szgiyp","i1ua728l":"i1ua728l"};